import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/organiza.png'


const _hoisted_1 = { class: "flex flex-col items-center mt-2 md:mt-12 w-full" }
const _hoisted_2 = { class: "flex flex-col md:flex-row gap-2 md:gap-4 mt-5 w-full px-4 text-center md:w-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: "plex-regular flex flex-col items-center justify-center bg-cover bg-center md:bg-left-top bg-no-repeat",
    style: _normalizeStyle({ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "object-contain w-11/12 md:w-10/12 lg:w-6/12 py-6 md:py-0",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "px-5 py-2 border border-[#57af4e] bg-[#57af4e] text-white font-semibold hover:bg-white hover:text-[#57af4e] rounded-2xl"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "pi pi-user mr-2" }, null, -1),
            _createTextVNode("VISITANTE ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/instituciones",
          class: "px-5 py-2 border border-[#57af4e] bg-[#57af4e] text-white font-semibold hover:bg-white hover:text-[#57af4e] rounded-2xl"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "pi pi-globe mr-2" }, null, -1),
            _createTextVNode("INSTITUCIONES ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/credenciales",
          class: "px-5 py-2 border border-[#57af4e] bg-[#57af4e] text-white font-semibold hover:bg-white hover:text-[#57af4e] rounded-2xl"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "pi pi-qrcode mr-2" }, null, -1),
            _createTextVNode("YA ME ACREDITÉ ", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "w-[60%] md:w-[30%] lg:w-[15%] object-contain py-4",
        src: _imports_1
      }, null, -1))
    ])
  ], 4))
}